const CUSTOM_JS_SCRIPT_ID = 'gallApp-custom-js';
const CLEANUP_GLOBAL = '__gallAppCustomJsCleanup';
const REGISTER_CLEANUP_GLOBAL = '__gallAppCustomJsRegisterCleanup';

const CUSTOM_JS_BOOTSTRAP = '(function(){' +
	'var cleanups=[];' +
	'window.' + REGISTER_CLEANUP_GLOBAL + '=function(fn){' +
		'if(typeof fn==="function"){cleanups.push(fn);}' +
	'};' +
	'window.' + CLEANUP_GLOBAL + '=function(){' +
		'while(cleanups.length){' +
			'var fn=cleanups.pop();' +
			'try{fn();}catch(e){console.error("[custom.js] cleanup failed",e);}' +
		'}' +
		'window.' + REGISTER_CLEANUP_GLOBAL + '=undefined;' +
	'};' +
'})();';

let injectedCustomJS = '';

interface GallAppCustomJsWindow {
	__gallAppCustomJsCleanup?: () => void;
	__gallAppCustomJsRegisterCleanup?: (fn: () => void) => void;
}

const getCustomWindow = (): GallAppCustomJsWindow => window as GallAppCustomJsWindow;

const runCustomJSCleanup = (): void => {
	const customWindow = getCustomWindow();
	const cleanup = customWindow.__gallAppCustomJsCleanup;

	if (typeof cleanup === 'function') {
		try {
			cleanup();
		} catch (error) {
			console.error('[custom.js] cleanup failed', error);
		}
	}

	customWindow.__gallAppCustomJsCleanup = undefined;
	customWindow.__gallAppCustomJsRegisterCleanup = undefined;
};

const removeCustomJS = (): void => {
	runCustomJSCleanup();

	const existing = document.getElementById(CUSTOM_JS_SCRIPT_ID);

	if (existing && existing.parentNode) {
		existing.parentNode.removeChild(existing);
	}

	injectedCustomJS = '';
};

const injectCustomJS = (content: string): void => {
	if (!content) {
		removeCustomJS();
		return;
	}

	if (injectedCustomJS === content) {
		return;
	}

	removeCustomJS();

	const script = document.createElement('script');
	script.id = CUSTOM_JS_SCRIPT_ID;
	script.type = 'text/javascript';
	script.text = CUSTOM_JS_BOOTSTRAP + '\n' + content;
	document.head.appendChild(script);
	injectedCustomJS = content;
};

export {
	injectCustomJS,
	removeCustomJS,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/customJs.ts